import { Injectable } from '@angular/core';

/**
 * Estado del menú lateral en mobile (el que se abre con el botón
 * hamburguesa ".btnMenu").
 *
 * Antes esto vivía en src/app/archivo.js, un script global cargado por
 * angular.json enganchado a "DOMContentLoaded" con document.querySelector.
 * En una SPA de Angular ese evento dispara antes de que Angular termine de
 * arrancar y renderizar el primer componente, así que ".hamburMobile" /
 * ".closeMenu" / "#overlay" todavía no existían en el DOM: el script
 * fallaba de inmediato con "Cannot read properties of null (reading
 * 'addEventListener')" y el menú hamburguesa nunca llegó a funcionar en
 * ninguna pantalla (ver también que "#overlay" vive en <app-footer>, un
 * componente aparte del que tiene el botón, así que ni con timing perfecto
 * hubiera sido un acoplamiento sano).
 *
 * Se reemplaza por este servicio: cada componente con el menú (banner,
 * bannerregistrados, bannerusuario, generarqr, redireccion) y el footer
 * (dueño de "#overlay") leen/mutan el mismo estado compartido con bindings
 * normales de Angular, sin depender de timing de carga ni de querySelector.
 *
 * "estado" tiene 3 valores en vez de un simple boolean para no reproducir
 * el "flash" de las animaciones CSS existentes (.leftMargin1/.leftMargin2,
 * ver styles.css): sus @keyframes arrancan el frame en 0% aunque el
 * elemento ya esté en otra posición, así que "cerrando" (que empieza en
 * left:0, visible) no debe aplicarse nunca de entrada, solo como reacción
 * a un cierre explícito.
 */
export type EstadoMenuMobile = 'cerrado' | 'abriendo' | 'cerrando';

@Injectable({
  providedIn: 'root'
})
export class MobileMenuService {
  estado: EstadoMenuMobile = 'cerrado';

  abrir(): void {
    this.estado = 'abriendo';
  }

  cerrar(): void {
    this.estado = 'cerrando';
  }
}
